/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { Mesh } from './InteractiveComponents';
export const metadata = {
  demo: Mesh,
  title: 'THREE.Mesh'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can crete a `}<a parentName="p" {...{
        "href": "https://threejs.org/docs/#api/en/objects/Mesh"
      }}>{`THREE.Mesh`}</a>{` by combining a `}<inlineCode parentName="p">{`THREE.Geometry`}</inlineCode>{` and `}<inlineCode parentName="p">{`THREE.Material`}</inlineCode>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Hint:`}</em>{` For performance, it's better to create one instance of `}<inlineCode parentName="p">{`THREE.Geometry`}</inlineCode>{` and re-use it for many meshes.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
